const krakenColorPalette = [
    '#FF3B29',
    '#de2224',
    '#f02f29',
    '#ef706d',
    '#f79996',
]

// red theme
export const clientThemeKraken = {
    mainLayout: {
        backgroundColor: '#fafaf9',
        hover: {
            backgroundColor: '#FF3B29',
        },
    },
    topBar: {
        backgroundColor: '',
        contrastText: '',
        contrastLinkText: '#098fe2',
        userIcon: '#FF3B29',
        brandLogo: {
            maxWidth: '160px',
            paddingTop: '',
        },
        menuBarIcon: {
            color: '#afafaf',
        },
    },
    sidebar: {
        fontSize: '14px',
        backgroundColor: '#333436',
        darkBackgroundColor: '#1f2024',
        sideMenuActive: {
            backgroundColor: '#4e5052',
            contrastText: '',
        },
        sideMenuHover: {
            backgroundColor: '',
            contrastText: '',
        },
    },
    footer: {
        backgroundColor: '',
        contrastText: '',
    },
    charts: {
        fill: '#FF3B29',
        stroke: '#FF3B29',
        lineCharts: {
            stroke: '#FF3B29',
            fill: '#FF3B29',
        },
        areaCharts: {
            gradient: {
                start: '#FF3B29',
                stop: '#FF3B29',
            },
            stroke: '#FF3B29',
            fill: '#FF3B29',
            chargebacksByPostDateChart: {
                stroke: '#FF3B29',
                fill: '#FF3B29',
            },
            newAlertsByDateChart: [
                {
                    stroke: 'rgb(255, 59, 41)',
                    fill: 'rgba(255, 59, 41, 0.5)',
                },
                {
                    stroke: 'rgb(222, 34, 36)',
                    fill: 'rgba(222, 34, 36, 0.5)',
                },
                {
                    stroke: 'rgb(240, 47, 41)',
                    fill: 'rgba(240, 47, 41, 0.5)',
                },
                {
                    stroke: 'rgb(239, 112, 109)',
                    fill: 'rgba(239, 112, 109, 0.5)',
                },
                {
                    stroke: 'rgb(247, 153, 150)',
                    fill: 'rgba(247, 153, 150, 0.5)',
                },
                {
                    stroke: 'rgba(128, 128, 128)',
                    fill: 'rgba(128, 128, 128, 0.5)',
                },
                {
                    stroke: 'rgba(38, 50, 56)',
                    fill: 'rgba(38, 50, 56, 0.5)',
                },
            ],
        },
        barCharts: {
            fill: '#FF3B29',
            byPlatformBarChart: { fill: '#FF3B29' },
            byBinBarChart: { fill: '#FF3B29' },
            ertsByRevenueChart: {
                bar1Fill: '#FF3B29',
                bar2Fill: '#EF706D',
            },
        },
        lineBarCharts: {
            byNonUniqueCustomerLineBarChart: {
                barColor: 'rgb(54, 119, 176)',
                lineColor: '#FF3B29',
            },
        },
        pieCharts: {
            defaultPieChart: krakenColorPalette,
            piePlotHeader: {
                fill: '#181D27',
                fontWeight: 600,
            },
        },
        radialBarCharts: {
            fill: '#FF3B29',
        },
    },
    lockAndUnlockButton: {
        lockButton: {},
        unlockButton: {},
    },
    lampColors: {
        green: '#57a537',
        red: '#cb2022',
        orange: '#d87707',
        yellow: '#d8d800',
        grey: 'grey',
    },
    uploadDnD: {
        borderColor: `#17A0DB`,
        backgroundColor: `rgba(208,230,246,.4)`,
        labelColor: `#17A0DB`,
    },
    metricTile: {
        arrow: {
            width: 28,
            height: 28,
        },
        metricValue: {
            fontWeight: 500,
            color: '#181D27',
        },
        metricTitle: {
            color: '#263238',
            fontSize: '14px',
        },
        metricTimeFrame: {
            color: '#a1a1aa',
            fontSize: '12px',
        },
    },
    caseBuilder: {
        color: '#FF3B29',
        saveAndContinueBtn: {},
        submittingColor: '#FF3B29',
        buttonThemeColor: 'primary',
    },
    accentAreaTopBorderAccent: {
        backgroundColor: '',
        borderRadius: '',
    },
    accentArea: {
        title: {
            fontWeight: 600,
            color: '#181D27',
            fontSize: '16px',
        },
        topBorderAccent: {
            backgroundColor: '#17A0DB',
            borderRadius: '4px',
        },
    },
    dateRangeContainer: {
        borderRadius: '',
        padding: '8px 7px',
    },
    selectionBox: {
        borderRadius: '4px',
    },
    formFields: {
        formLabel: {},
        formText: {
            standard: {
                color: '',
            },
            outlined: {
                fontSize: '',
            },
        },
    },
    labelTags: {
        borderRadius: '16px',
        backgroundColor: '#e0e0e0',
    },
    searchBar: {
        padding: '6px',
    },
    buttons: {
        styleButton: {
            root: {
                textTransform: 'capitalize',
            },
            contained: {
                textTransform: 'capitalize',
            },
        },
        defaultButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#E0E0E0',
                color: 'rgba(0, 0, 0, 0.87)',
                '&:hover': {
                    backgroundColor: '#d5d5d5',
                },
            },
        },
        textOrOutlinedButton: {
            variant: 'outlined',
            style: {
                border: '1px solid #DDE2EB !important',
                borderRadius: '4px !important',
                color: '#263238',
                fontWeight: 600,
                padding: '4px 10px',
                fontSize: '13px',
                '&:hover': {
                    backgroundColor: 'rgba(38, 50, 56, 0.04)',
                },
            },
        },
        greyButton: {
            variant: 'contained',
            style: {
                color: '#4f4f4f',
                backgroundColor: '#D5D5D5',
                '&:hover': {
                    color: '#4f4f4f',
                    backgroundColor: '#D5D5D5',
                },
            },
        },
        greenButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#3ED4AF',
                '&:hover': {
                    backgroundColor: '#3ac5a2',
                },
            },
        },
        activeStateButton: {
            color: 'white',
            backgroundColor: '#61656E',
        },
    },
    icons: {
        uploadIcon: '#3cb4e5',
        dnrAndRevertDnrIcon: '#c80000',
        reviewIcon: '#3cb4e5',
        toggleUnlockIcon: '#75797b',
        toggleLockIcon: '#c80000',
        editUserIcon: '#2a7ea0',
        midPermissionIcon: '#714eb1',
        sitePermissionIcon: '#f88d2b',
        tempPasswordIcon: '#3cb4e5',
    },
    main: '#FF3B29',
    primaryLight: '#FF6253',
    primary: '#FF3B29',
    primaryDark: '#de2224',
    secondaryLight: '#FF6253',
    secondary: '#FF3B29',
    secondaryDark: '#de2224',
    hyperlink: '#098fe2',
    textField: '#263238',
    switch: '#FF3B29',
    typography: {
        fontColor: {
            primaryText: '',
            secondaryText: '',
        },
        fontFamily: ['Kraken', 'Source Sans Pro', 'sans-serif'],
        fontFamilyConfig: {
            primary: 'Kraken',
            fallback:
                'Source Sans Pro, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Arial, sans-serif',
        },
        fontFamilyClass: 'kraken-font',
        h1: {
            fontSize: '34px',
        },
        h2: {
            fontSize: '28px',
        },
        h3: {
            fontSize: '23px',
        },
        h4: {
            fontSize: '19px',
        },
        h5: {
            fontSize: '15px',
        },
        h6: {
            fontSize: '12px',
        },
        subtitle1: {
            fontSize: '15px',
        },
        subtitle2: {
            fontSize: '12px',
        },
        subtitle3: {
            fontSize: '15px',
        },
        subtitle4: {
            fontSize: '12px',
        },
        body1: {
            fontSize: '13px',
        },
        body2: {
            fontSize: '12px',
        },
        button1: {
            fontSize: '13px',
        },
        button2: {
            fontSize: '13px',
        },
        caption: {
            fontSize: '11px',
        },
        overline: {
            fontSize: '10px',
        },
        label: {
            fontSize: '13px',
        },
        dataGrid: {
            tableHeader: {
                fontSize: '12.8px',
            },
            tableBody: {
                fontSize: '13px',
                color: '#464646',
            },
            tableExpandable: {
                fontSize: '13px',
            },
        },
    },
}
